import Vue from "vue";
import router from "../../router";

export async function fetchCategories({ commit }) {
  commit("setLoading", true)
  try {
    const { data } = await Vue.axios({
      method: "GET",
      url: `/frontend/hc_categories`
    })

    return data
  } catch (e) {
    return false
  } finally {
    commit("setLoading", false)
  }
}

export async function fetchCategoriesAll({ commit }) {
  commit("setLoading", true)
  try {
    const { data } = await Vue.axios({
      method: "GET",
      url: `/frontend/hc_categories/categories_all`
    })

    return data
  } catch (e) {
    return false
  } finally {
    commit("setLoading", false)
  }
}

export async function fetchQuestionsImportant({ commit }) {
  commit("setLoading", true)
  try {
    const { data } = await Vue.axios({
      method: "GET",
      url: `/frontend/hc_questions/importants`
    })

    return data
  } catch (e) {
    return false
  } finally {
    commit("setLoading", false)
  }
}

export async function fetchCategory({ commit }, categorySlug) {
  commit("setLoading", true)
  try {
    const { data } = await Vue.axios({
      method: "GET",
      url: `/frontend/hc_categories/${categorySlug}`
    })

    return data
  } catch (e) {
    return false
  } finally {
    commit("setLoading", false)
  }
}

export async function fetchSubcategory({ commit }, subcategorySlug) {
  commit("setLoading", true)
  try {
    const { data } = await Vue.axios({
      method: "GET",
      url: `/frontend/hc_subcategories/${subcategorySlug}`
    })

    return data
  } catch (e) {
    return false
  } finally {
    commit("setLoading", false)
  }
}

export async function fetchQuestion({ commit }, questionId) {
  commit("setLoading", true)
  try {
    const { data } = await Vue.axios({
      method: "GET",
      url: `/frontend/hc_questions/${questionId}`
    })

    return data
  } catch (e) {
    router.push("/centro-de-ayuda")
  } 
  finally {
    commit("setLoading", false)
  }
}

export async function fetchSearch({ commit }, payload) {
  commit("setLoading", true)
  try {
    const { data } = await Vue.axios({
      method: "GET",
      url: `/frontend/hc_questions/search`,
      params: { search: payload }
    })

    return data
  } catch (e) {
    return false
  } 
  finally {
    commit("setLoading", false)
  }
}

export async function createTicket({ commit }, payload) {
  try {
    const { data } = await Vue.axios({
      method: "POST",
      url: `/frontend/hc_tickets`,
      data: payload
    })

    return data
  } catch (e) {
    return false
  } 
  finally {}
}

export async function fetchTickets({ commit }, status) {
  try {
    const { data } = await Vue.axios({
      method: "GET",
      url: `/frontend/hc_tickets`,
      params: { status }
    })

    return data
  } catch (e) {
    return false
  } 
  finally {}
}

export async function fetchTicket({ commit }, id) {
  try {
    const { data } = await Vue.axios({
      method: "GET",
      url: `/frontend/hc_tickets/${id}`
    })

    return data
  } catch (e) {
    router.push("/centro-de-ayuda")
  } 
  finally {}
}

export async function closeTicket({ commit }, id) {
  try {
    const { data } = await Vue.axios({
      method: "PUT",
      url: `/frontend/hc_tickets/${id}/close`
    })

    return data
  } catch (e) {
    router.push("/centro-de-ayuda")
  } 
  finally {}
}

export async function createMessage({ commit }, payload) {
  try {
    const { data } = await Vue.axios({
      method: "POST",
      url: `/frontend/hc_tickets/${payload.ticketId}/hc_messages`,
      data: payload.formData
    })

    return data
  } catch (e) {
    return false
  } 
  finally {}
}

export async function createSatisfactionAnswer({ commit }, payload) {
  try {
    const { data } = await Vue.axios({
      method: "POST",
      url: `/frontend/hc_tickets/${payload.ticketId}/hc_satisfaction_answers`,
      data: { answer: { value: payload.value } }
    })

    return data
  } catch (e) {
    return false
  } 
  finally {}
}